/**
 * Modellen toewijzen aan een chatter: één regel per model, met FC/F2F-badges.
 *
 * 30-09-2026 (Jordy): de lijst in Create/Edit chatter toonde elk profiel los
 * (AliceIMonta twee keer: FC en F2F), plus inactieve modellen die de server
 * weigerde ("outside your assigned model scope"). Nu krijgt dit onderdeel
 * alleen actieve, platform-gekoppelde modellen (de aanroeper vraagt die op
 * met active_only + linked_only) en groepeert het de profielen van hetzelfde
 * model. Een vinkje wijst beide profielen toe; Select all / Deselect all doet
 * dat voor alles. Ids die hier niet in de lijst staan (bv. een oude
 * toewijzing) laat het ongemoeid.
 */
import { Tag } from './ui'

export interface ModelOptie {
  id: number
  slug: string
  stage_name: string | null
  fancentro_model_id?: string | null
  f2f_model_id?: string | null
}

interface Groep { sleutel: string; naam: string; ids: number[]; fc: boolean; f2f: boolean }

export function groepeerModellen(modellen: ModelOptie[]): Groep[] {
  const per = new Map<string, Groep>()
  for (const m of modellen) {
    const naam = (m.stage_name || m.slug).trim()
    const sleutel = naam.toLowerCase()
    const g = per.get(sleutel) ?? { sleutel, naam, ids: [], fc: false, f2f: false }
    g.ids.push(m.id)
    g.fc = g.fc || Boolean(m.fancentro_model_id) || m.slug.startsWith('fc_')
    g.f2f = g.f2f || Boolean(m.f2f_model_id) || m.slug.startsWith('f2f_')
    per.set(sleutel, g)
  }
  return [...per.values()].sort((a, b) => a.naam.localeCompare(b.naam))
}

export function ModelKeuze({
  modellen,
  gekozen,
  onChange,
}: {
  modellen: ModelOptie[]
  gekozen: number[]
  onChange: (ids: number[]) => void
}) {
  const groepen = groepeerModellen(modellen)
  const alleIds = groepen.flatMap((g) => g.ids)
  const zet = (ids: number[], aan: boolean) => {
    const rest = gekozen.filter((x) => !ids.includes(x))
    onChange(aan ? [...rest, ...ids] : rest)
  }
  return (
    <>
      <div className="row" style={{ gap: 6, marginBottom: 6 }}>
        <button className="btn ghost sm" type="button" onClick={() => zet(alleIds, true)}>
          Select all
        </button>
        <button className="btn ghost sm" type="button" onClick={() => zet(alleIds, false)}>
          Deselect all
        </button>
      </div>
      <div className="cols" style={{ gridTemplateColumns: '1fr 1fr', gap: 4 }}>
        {groepen.map((g) => {
          const aantal = g.ids.filter((x) => gekozen.includes(x)).length
          const aan = aantal === g.ids.length
          return (
            <label className="chkrow" key={g.sleutel} style={{ cursor: 'pointer' }}
                   onClick={() => zet(g.ids, !aan)}>
              <span className={aan ? 'chk on' : 'chk'}>{aan ? '✓' : aantal ? '–' : ''}</span>
              {g.naam}
              {g.fc ? <>{' '}<Tag kind="mut">FC</Tag></> : null}
              {g.f2f ? <>{' '}<Tag kind="mut">F2F</Tag></> : null}
            </label>
          )
        })}
      </div>
    </>
  )
}
